import { Box, TextField, Grid, Button, useMediaQuery } from "@mui/material";
import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";

export default function Form() {
  const form = useRef();
  const matches = useMediaQuery("(min-width:464px)");
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const handleComment = (event) => {
    setComment(event.target.value);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    const service_id = "service_dwpn74x";
    const templete_id = "template_y26ag7v";
    const public_key = "FjyaUwYaMFEebx_vB";
    if (name && comment) {
      emailjs.sendForm(service_id, templete_id, form.current, public_key).then(
        (result) => {
          if (result.text === "OK") {
            alert("Message Send Successfully");
            setName("");
            setEmail("");
            setComment("");
            window.location.reload(true);
          }
        },
        (error) => {
          console.log(error.text);
        }
      );
    } else {
      alert("Name and message fields can`t be empty");
    }
  };
  return (
    <div dir={isArabic ? "rtl" : "ltr"}>
      <form ref={form} onSubmit={sendEmail}>
        <Box
          sx={{
            height: matches ? "280px" : "",
            width: matches ? "390px" : "280px",
            padding: "20px",
            borderRadius: "20px",
            bgcolor: "#759BE39C",
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid sx={{ justifyContent: "start", alignItems: "start" }}>
            <TextField
              name="from_name"
              label={t("FirstName")}
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              sx={{
                width: "180px",
                ".MuiInputBase-root": {
                  borderRadius: "20px",
                  bgcolor: "#F9F7F7",
                },
              }}
            />
          </Grid>
          <Grid sx={{ justifyContent: "start", alignItems: "start" }}>
            <TextField
              name="from_email"
              label={t("YourEmail")}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              sx={{
                width: "180px",
                ".MuiInputBase-root": {
                  borderRadius: "20px",
                  bgcolor: "#F9F7F7",
                },
              }}
            />
          </Grid>
          <textarea
            onChange={handleComment}
            placeholder={t("Message")}
            name="message"
            style={{
              borderRadius: "20px",
              backgroundColor: "#FFFFFF",
              height: "100px",
              padding: "10px",
              width: "350px",
            }}
          />

          <Button
            type="submit"
            sx={{
              backgroundColor: "#030D55",
              color: "white",
              width: "150px",
              borderRadius: "10px",
              "&:hover": { backgroundColor: "#030D55" },
            }}
          >
            {t("Send Message")}
          </Button>
        </Box>
      </form>
    </div>
  );
}
